/* Elysian hero v6 (exploratory, 2026-09-26; built from v5). Loaded by sections/elysian-hero-v6.liquid only.
   1. Shop Coffee smooth scroll (below). 2. Depth-lag fallback for browsers without CSS scroll-driven animations (Firefox): the same values and range as the CSS,
      transform only, one rAF per frame, and only while the hero is on screen. */
(function () {
  var heroes = document.querySelectorAll('.ely-hv6');
  if (!heroes.length) return;

  /* Nav trial sticker (2026-09-29): one wiggle on mouse hover and on tap or click, restarting on a repeat; the CSS runs it only
     without reduced motion. */
  document.querySelectorAll('.ely-hv6 [data-hv6-badge]').forEach(function (badge) {
    var wiggle = function () { badge.classList.remove('is-wiggle'); void badge.offsetWidth; badge.classList.add('is-wiggle'); };
    badge.addEventListener('animationend', function (e) { if (e.animationName === 'ely-shipfree-wiggle') badge.classList.remove('is-wiggle'); });
    /* hover wiggle removed 2026-09-29 (Chris): the sticker wiggles when the curtain lands in it and on a tap or click, never on hover */
    badge.addEventListener('click', wiggle);
  });

  /* Shop Coffee: a slow, eased scroll to the in-page target (the Foundation section) so the ranges are seen moving on the way down.
     easeInOutCubic, 1400 to 1800ms scaled by distance; lands the target's heading 32px below any pinned header; any wheel, touch,
     key or pointer input cancels it. Reduced motion: an instant jump to the same spot. Without JS the plain #anchor link still works. */
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var pinnedHeaderHeight = function () {
    var h = 0;
    document.querySelectorAll('.ely-header, sticky-header, .section-header').forEach(function (el) {
      var pos = getComputedStyle(el).position;
      var r = el.getBoundingClientRect();
      if ((pos === 'sticky' || pos === 'fixed') && r.top <= 1 && r.bottom > 0) h = Math.max(h, r.bottom);
    });
    return h;
  };
  var easeInOutCubic = function (t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };
  document.querySelectorAll('.ely-hv6 [data-hv6-smooth]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var href = link.getAttribute('href') || '';
      if (href.charAt(0) !== '#' || href.length < 2) return;
      var target = document.getElementById(decodeURIComponent(href.slice(1)));
      if (!target) return;
      e.preventDefault();
      var anchor = target.querySelector('h1, h2, h3') || target;
      var destination = function () {
        var y = window.pageYOffset + anchor.getBoundingClientRect().top - pinnedHeaderHeight() - 32;
        var max = document.documentElement.scrollHeight - window.innerHeight;
        return Math.max(0, Math.min(y, max));
      };
      var finish = function () {
        if (!anchor.hasAttribute('tabindex')) anchor.setAttribute('tabindex', '-1');
        try { anchor.focus({ preventScroll: true }); } catch (err) { /* very old engines: skip focus rather than jump */ }
        if (history.replaceState) history.replaceState(null, '', href);
      };
      /* plain scrollTo(x, y) everywhere (no behavior option), with any CSS smooth scrolling paused while we drive the frames */
      var root = document.documentElement;
      var prevBehavior = root.style.scrollBehavior;
      root.style.scrollBehavior = 'auto';
      var restore = function () { root.style.scrollBehavior = prevBehavior; };
      if (reduceMotion) { window.scrollTo(0, destination()); restore(); finish(); return; }
      var start = window.pageYOffset;
      var distance = destination() - start;
      var duration = Math.min(1800, Math.max(1400, 1100 + Math.abs(distance) * 0.5));
      var t0 = null;
      var cancelled = false;
      var cancel = function () { cancelled = true; };
      var events = ['wheel', 'touchstart', 'keydown', 'mousedown'];
      events.forEach(function (ev) { window.addEventListener(ev, cancel, { passive: true, once: true }); });
      var cleanup = function () { events.forEach(function (ev) { window.removeEventListener(ev, cancel); }); };
      var step = function (now) {
        if (cancelled) { cleanup(); restore(); return; }
        if (t0 === null) t0 = now;
        var t = Math.min((now - t0) / duration, 1);
        window.scrollTo(0, start + distance * easeInOutCubic(t));
        if (t < 1) requestAnimationFrame(step);
        else { cleanup(); restore(); finish(); }
      };
      requestAnimationFrame(step);
    });
  });

  /* Scroll motion. Where CSS scroll-driven animations exist (CSS.supports is feature-detected), the CSS moves the layers (the headline
     and fades the headline, bag and button group; this handler then only switches the button's pointer-events off while it is
     nearly invisible. Elsewhere (Firefox, Safari before 26) it drives the same values over the same range: page scroll 0 to (everything
     above the hero + its design height). */
  var cssDriven = !!(window.CSS && CSS.supports && CSS.supports('animation-timeline: scroll()'));
  if (reduceMotion) return;
  /* the group (headline, bag, button): opacity 1 until 20% of the range, 0 by 55%; now 24% to 66%, phones 30% to 65% (2026-09-27, as the CSS) */
  var phoneMq = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
  var textOpacity = function (p) {
    var phone = phoneMq && phoneMq.matches;
    var a = phone ? 0.3 : 0.24, b = phone ? 0.65 : 0.66;
    return p <= a ? 1 : p >= b ? 0 : 1 - (p - a) / (b - a);
  };

  heroes.forEach(function (hero) {
    var layers = Array.prototype.map.call(hero.querySelectorAll('.ely-hv6__layer'), function (el) {
      return { el: el, factor: parseFloat(getComputedStyle(el).getPropertyValue('--hv6-depth')) || 0 };
    });
    var group = Array.prototype.slice.call(hero.querySelectorAll('.ely-hv6__title-wrap, .ely-hv6__bag-wrap, .ely-hv6__cta'));
    var cta = hero.querySelector('.ely-hv6__cta');
    /* --hv6-h (the design height) resolved to px with a probe; Dawn hides empty divs, hence display:block */
    var unit = 0;
    var measure = function () {
      var probe = document.createElement('div');
      probe.style.cssText = 'display:block;position:absolute;visibility:hidden;width:0;height:var(--hv6-h)';
      hero.appendChild(probe);
      unit = probe.getBoundingClientRect().height;
      hero.removeChild(probe);
    };
    measure();
    var queued = false;
    var update = function () {
      queued = false;
      var above = parseFloat(getComputedStyle(hero).getPropertyValue('--hv6-chrome')) || 104;
      var p = Math.min(Math.max((window.pageYOffset || 0) / (above + unit), 0), 1);
      var op = textOpacity(p);
      if (!cssDriven) {
        for (var i = 0; i < layers.length; i++) {
          /* layers move once all five paintings are in; until then the base stands in for them */
          var on = layers[i].el.classList.contains('is-in');
          layers[i].el.style.transform = on ? 'translate3d(0,' + (p * layers[i].factor * unit).toFixed(2) + 'px,0)' : '';
        }
        /* the group (headline, bag, button) only fades, 20% to 55%, then is hidden; no transform, exactly as the CSS */
        for (var j = 0; j < group.length; j++) {
          group[j].style.opacity = op.toFixed(3);
          group[j].style.visibility = op <= 0 ? 'hidden' : '';
        }
      }
      if (cta) cta.style.pointerEvents = op < 0.2 ? 'none' : '';
    };
    var onScroll = function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(update);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    /* resize: measure once per frame, not once per event (each measure forces a layout; dragging a window fires dozens a second) */
    var sized = false;
    window.addEventListener('resize', function () {
      if (sized) return;
      sized = true;
      requestAnimationFrame(function () { sized = false; measure(); update(); });
    }, { passive: true });
    onScroll();
  });
})();
